export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览全部韩国漫画作品' },
  { slug: 'romance', name: '爱情', icon: 'ri-heart-line', description: '浪漫甜蜜的爱情韩漫故事' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', description: '紧张刺激的悬疑推理韩漫' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界韩漫' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血激燃的动作韩漫作品' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的喜剧韩漫' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '深刻动人的剧情韩漫' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', description: '青春洋溢的校园韩漫' },
];

export const comics: Comic[] = [
  {
    id: 'secret-class',
    title: '秘密教学',
    author: 'YongHan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20woman%20and%20man%20in%20a%20romantic%20embrace%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20clean%20lines%2C%20simple%20light%20gradient%20background%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    description: '从小失去父母的志豪，被父亲的好友收养。在这个新家庭里，他遇到了两个性格迥异的姐姐。随着时间推移，一段禁忌又甜蜜的秘密关系悄然展开...',
    category: 'romance',
    tags: ['爱情', '校园', '日常'],
    rating: 4.8,
    views: 2850000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'sc-ch-1', title: '第1话 - 新的家庭', number: 1, updatedAt: '2025-01-15' },
      { id: 'sc-ch-2', title: '第2话 - 初次见面', number: 2, updatedAt: '2025-01-22' },
      { id: 'sc-ch-3', title: '第3话 - 心跳加速', number: 3, updatedAt: '2025-01-29' },
      { id: 'sc-ch-4', title: '第4话 - 不能说的秘密', number: 4, updatedAt: '2025-02-05' },
      { id: 'sc-ch-5', title: '第5话 - 靠近的心', number: 5, updatedAt: '2025-02-12' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'beauty-bring',
    title: '女神降临',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20featuring%20a%20stunning%20woman%20with%20makeup%20transformation%2C%20glamorous%20style%2C%20half%20face%20before%20and%20after%20makeup%2C%20Korean%20webtoon%20art%20style%2C%20soft%20pink%20and%20peach%20tones%2C%20clean%20gradient%20background&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    description: '因为外貌被欺负的朱静，通过化妆技巧蜕变成了校园女神。但在这个看脸的世界里，她能找到真正的幸福吗？两个帅气男生同时出现在她身边...',
    category: 'romance',
    tags: ['爱情', '校园', '美妆'],
    rating: 4.9,
    views: 5630000,
    status: '已完结',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'bb-ch-1', title: '第1话 - 新的开始', number: 1, updatedAt: '2024-06-01' },
      { id: 'bb-ch-2', title: '第2话 - 蜕变', number: 2, updatedAt: '2024-06-08' },
      { id: 'bb-ch-3', title: '第3话 - 男神降临', number: 3, updatedAt: '2024-06-15' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'killer-peter',
    title: '杀手彼得',
    author: 'Kim Jae-Hwan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20cover%20of%20a%20mysterious%20man%20in%20a%20black%20suit%20holding%20a%20gun%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20dark%20red%20and%20black%20gradient%20background%2C%20cinematic%20composition&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    description: '曾是传奇杀手的彼得，为了寻找失踪的妹妹重出江湖。然而等待他的，是一个横跨黑白两道的巨大阴谋。每一步都可能是陷阱，每一个人都可能是敌人。',
    category: 'action',
    tags: ['动作', '悬疑', '复仇'],
    rating: 4.7,
    views: 1920000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'kp-ch-1', title: '第1话 - 退休生活', number: 1, updatedAt: '2025-03-10' },
      { id: 'kp-ch-2', title: '第2话 - 噩耗', number: 2, updatedAt: '2025-03-17' },
      { id: 'kp-ch-3', title: '第3话 - 重返江湖', number: 3, updatedAt: '2025-03-24' },
      { id: 'kp-ch-4', title: '第4话 - 蛛丝马迹', number: 4, updatedAt: '2025-03-31' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'dungeon-reset',
    title: '地下城重置',
    author: 'Daon Creative',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20with%20a%20young%20warrior%20in%20a%20dungeon%20setting%2C%20magical%20glowing%20effects%2C%20fantasy%20adventure%20vibe%2C%20Korean%20webtoon%20art%20style%2C%20mystical%20blue%20and%20purple%20gradient%20background%2C%20epic%20composition&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    description: '被召唤到异世界的俊秀，发现自己拥有重置地下城的特殊能力。每一次死亡都是一次新的开始，他能否利用这个能力征服所有地下城？',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '游戏'],
    rating: 4.6,
    views: 1450000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'dr-ch-1', title: '第1话 - 异世界召唤', number: 1, updatedAt: '2025-05-20' },
      { id: 'dr-ch-2', title: '第2话 - 第一个地下城', number: 2, updatedAt: '2025-05-27' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20thriller%20Korean%20manhwa%20cover%20showing%20a%20dark%20apartment%20building%20with%20monstrous%20shadows%2C%20apocalyptic%20atmosphere%2C%20Korean%20webtoon%20style%2C%20dark%20green%20and%20black%20gradient%2C%20survival%20horror%20theme&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    description: '车贤秀在失去家人后搬进了一栋老旧公寓。然而一种神秘的怪物病毒开始在城市蔓延，公寓的居民们必须团结起来对抗怪物，才能在这场末日浩劫中生存下去。',
    category: 'suspense',
    tags: ['悬疑', '恐怖', '生存'],
    rating: 4.9,
    views: 4200000,
    status: '已完结',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'sh-ch-1', title: '第1话 - 新家', number: 1, updatedAt: '2024-01-10' },
      { id: 'sh-ch-2', title: '第2话 - 异变', number: 2, updatedAt: '2024-01-17' },
      { id: 'sh-ch-3', title: '第3话 - 怪物', number: 3, updatedAt: '2024-01-24' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tower-god',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20adventure%20Korean%20manhwa%20cover%20with%20a%20boy%20climbing%20a%20massive%20mysterious%20tower%2C%20epic%20scale%2C%20magical%20energy%2C%20Korean%20webtoon%20art%20style%2C%20warm%20golden%20and%20amber%20gradient%20background&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    description: '追寻着唯一的朋友蕾哈尔，少年夜闯入了神秘的神之塔。在塔的每一层都隐藏着致命的试炼，而他心中只有一个信念：找到蕾哈尔，无论付出什么代价。',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '友情'],
    rating: 4.9,
    views: 7800000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'tg-ch-1', title: '第1话 - 塔的入口', number: 1, updatedAt: '2023-06-01' },
      { id: 'tg-ch-2', title: '第2话 - 第一层试炼', number: 2, updatedAt: '2023-06-08' },
      { id: 'tg-ch-3', title: '第3话 - 王冠游戏', number: 3, updatedAt: '2023-06-15' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'daily-chaos',
    title: '日常混乱',
    author: 'Lee Hyun-Min',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedic%20Korean%20manhwa%20cover%20with%20a%20funny%20expression%20female%20character%20in%20office%20setting%2C%20chibi%20style%20elements%2C%20bright%20yellow%20and%20orange%20tones%2C%20Korean%20webtoon%20art%20style%2C%20playful%20vibe%2C%20clean%20white%20background&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    description: '平凡上班族金美英的日常充满了各种意想不到的混乱。从奇葩同事到离谱上司，每一天都是一场爆笑喜剧。在这个职场生存记中，笑料不断！',
    category: 'comedy',
    tags: ['喜剧', '职场', '日常'],
    rating: 4.5,
    views: 980000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'dc-ch-1', title: '第1话 - 第一天上班', number: 1, updatedAt: '2025-08-01' },
      { id: 'dc-ch-2', title: '第2话 - 奇葩同事', number: 2, updatedAt: '2025-08-08' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'spring-blossom',
    title: '春日花开',
    author: 'Park Soo-Jin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20school%20life%20Korean%20manhwa%20cover%20with%20cherry%20blossom%20petals%2C%20a%20young%20couple%20under%20a%20tree%2C%20soft%20spring%20colors%2C%20Korean%20webtoon%20art%20style%2C%20dreamy%20pink%20and%20white%20gradient%20background&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    description: '高二那年春天，转学生李春在樱花树下遇见了校园里的风云人物金在彦。一段青涩而美好的校园初恋，伴随着春天的花瓣悄然绽放。',
    category: 'school',
    tags: ['校园', '爱情', '青春'],
    rating: 4.7,
    views: 1350000,
    status: '已完结',
    updatedAt: '2026-07-28',
    chapters: [
      { id: 'sb-ch-1', title: '第1话 - 樱花树下的相遇', number: 1, updatedAt: '2024-03-01' },
      { id: 'sb-ch-2', title: '第2话 - 同桌的你', number: 2, updatedAt: '2024-03-08' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'shadow-detective',
    title: '暗影侦探',
    author: 'Choi Min-Suk',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20noir%20detective%20Korean%20manhwa%20cover%20with%20a%20trench%20coat%20detective%20under%20streetlight%2C%20rainy%20night%2C%20mystery%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20moody%20blue-gray%20gradient%20background&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    description: '前刑警姜道贤开了一家私人侦探所。某天一位神秘女子找上门来，委托他调查一起看似普通的失踪案，却意外揭开了一座城市最黑暗的秘密。',
    category: 'suspense',
    tags: ['悬疑', '推理', '犯罪'],
    rating: 4.6,
    views: 1120000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'sd-ch-1', title: '第1话 - 神秘的委托人', number: 1, updatedAt: '2025-07-01' },
      { id: 'sd-ch-2', title: '第2话 - 失踪的教授', number: 2, updatedAt: '2025-07-08' },
      { id: 'sd-ch-3', title: '第3话 - 城市暗面', number: 3, updatedAt: '2025-07-15' },
    ],
    isHot: false,
    isNew: true,
  },
  {
    id: 'revenge-queen',
    title: '复仇女王',
    author: 'Jung Seo-Yeon',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20woman%20in%20elegant%20dress%20with%20cold%20expression%2C%20revenge%20theme%2C%20luxurious%20setting%2C%20Korean%20webtoon%20art%20style%2C%20deep%20red%20and%20black%20gradient%20background&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    description: '被丈夫和闺蜜联手背叛后，韩素希失去了一切。三年后，她以全新身份归来，发誓要让那些伤害过她的人付出代价。一场精心策划的复仇大戏，即将拉开帷幕。',
    category: 'drama',
    tags: ['剧情', '复仇', '商战'],
    rating: 4.8,
    views: 2100000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'rq-ch-1', title: '第1话 - 坠落', number: 1, updatedAt: '2025-09-01' },
      { id: 'rq-ch-2', title: '第2话 - 新生', number: 2, updatedAt: '2025-09-08' },
      { id: 'rq-ch-3', title: '第3话 - 归来', number: 3, updatedAt: '2025-09-15' },
      { id: 'rq-ch-4', title: '第4话 - 第一步棋', number: 4, updatedAt: '2025-09-22' },
    ],
    isHot: true,
    isNew: false,
  },
  {
    id: 'blade-warrior',
    title: '剑之勇者',
    author: 'Kang Tae-Ho',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20action%20Korean%20manhwa%20cover%20with%20a%20swordsman%20in%20dynamic%20battle%20pose%2C%20martial%20arts%20theme%2C%20dramatic%20action%20lines%2C%20Korean%20webtoon%20art%20style%2C%20fiery%20orange%20and%20red%20gradient%20background&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    description: '在剑术没落的时代，少年韩真宇意外获得了上古剑圣的传承。为了守护珍视的人，他握紧了剑，踏上了一条充满血与火的武者之路。',
    category: 'action',
    tags: ['动作', '武侠', '热血'],
    rating: 4.5,
    views: 870000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'bw-ch-1', title: '第1话 - 废柴少年', number: 1, updatedAt: '2025-11-01' },
      { id: 'bw-ch-2', title: '第2话 - 剑圣传承', number: 2, updatedAt: '2025-11-08' },
    ],
    isHot: false,
    isNew: false,
  },
  {
    id: 'magic-academy',
    title: '魔法学院',
    author: 'Yoon Soo-Ah',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20school%20Korean%20manhwa%20cover%20with%20students%20in%20magical%20academy%20uniforms%2C%20spell%20effects%2C%20castle-like%20school%20building%2C%20Korean%20webtoon%20art%20style%2C%20mystical%20emerald%20and%20gold%20gradient%20background&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    description: '普通高中生林智雅意外收到了魔法学院的入学通知书。在这个充满魔法与奇幻的校园里，她发现自己身世中隐藏着一个惊人的秘密。',
    category: 'fantasy',
    tags: ['奇幻', '校园', '魔法'],
    rating: 4.6,
    views: 1680000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ma-ch-1', title: '第1话 - 意外的通知书', number: 1, updatedAt: '2025-10-01' },
      { id: 'ma-ch-2', title: '第2话 - 魔法学院', number: 2, updatedAt: '2025-10-08' },
    ],
    isHot: false,
    isNew: false,
  },
];

export const aboutInfo = {
  brandName: '韩漫大全',
  slogan: '无删减韩漫，原汁原味的阅读体验',
  introduction: '韩漫大全成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供最全面、最高质量的韩国漫画资源。所有漫画均经过正版授权，确保无删减、原汁原味的阅读体验。',
  mission: '让每一位漫画爱好者都能轻松享受韩国漫画的魅力，打造中文漫画圈最优质的韩漫阅读社区。',
  values: [
    { title: '品质至上', description: '我们坚持提供高清画质、精准翻译的漫画内容，绝不妥协于低质量的盗版资源。' },
    { title: '读者为本', description: '以读者体验为核心，持续优化阅读器功能，提供流畅舒适的阅读环境。' },
    { title: '内容丰富', description: '持续引进热门韩漫作品，覆盖爱情、悬疑、奇幻等多种题材，满足不同读者的口味。' },
  ],
  stats: [
    { label: '收录作品', value: '5000+' },
    { label: '日活读者', value: '30万+' },
    { label: '累计阅读', value: '5亿+' },
    { label: '用户好评', value: '98%' },
  ],
  contact: {
    email: 'contact@manhuakr.com',
    wechat: '韩漫大全官方',
    weibo: '@韩漫大全',
    address: '北京市朝阳区望京SOHO T2-1206',
  },
  faqs: [
    {
      question: '韩漫大全上的漫画都是正版吗？',
      answer: '是的，我们平台上的所有韩国漫画均经过正版授权，确保内容合法合规。我们与多家韩国知名漫画出版社建立了长期合作关系，为读者提供高质量的阅读体验。',
    },
    {
      question: '是否需要付费才能阅读？',
      answer: '我们提供大量免费漫画供读者阅读。部分热门连载作品设有付费章节，但我们也会定期推出限时免费活动，让更多读者享受优质内容。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: '韩漫大全支持全平台阅读，包括PC端、手机浏览器、平板等设备。我们针对不同屏幕尺寸进行了专门的适配优化，确保在任何设备上都能获得流畅的阅读体验。',
    },
    {
      question: '更新频率是怎样的？',
      answer: '热门连载作品通常每周更新1-2话，具体更新频率取决于原作者和出版社的安排。我们会在第一时间同步更新，读者可以关注喜欢的作品获取最新动态。',
    },
    {
      question: '如何搜索想看的漫画？',
      answer: '您可以通过网站顶部的搜索框输入漫画名称或关键词进行搜索，也可以通过分类浏览功能按题材筛选喜欢的漫画作品。',
    },
  ],
};